import { TableColumnProps } from '../../../Table';
import { ListIconColumnProps } from '../../types';

/**
 * Returns true if column is ListIconColumnProps.
 * @param column the column
 * @returns whether the column is the icon column
 */
export const isIconColumn = (column: TableColumnProps): column is ListIconColumnProps =>
  'cellIcon' in column || 'cellHelpPopup' in column;
